import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter({
  before,
  after,
  beforeLabel = "Prima",
  afterLabel = "Dopo",
  aspect = "aspect-[2/3]",
}) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(94, Math.max(6, p)));
  };

  const onPointerDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    move(e.clientX);
  };
  const onPointerMove = (e) => {
    if (e.buttons > 0) move(e.clientX);
  };

  return (
    <div
      ref={ref}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      className={`relative w-full ${aspect} mx-auto overflow-hidden rounded-[2rem] border border-line shadow-lift cursor-ew-resize touch-none select-none bg-sand`}
      data-testid="before-after-comparison"
    >
      <img
        src={after}
        alt="Sorriso dopo il trattamento"
        className="absolute inset-0 w-full h-full object-cover"
        draggable={false}
        data-testid="after-photo"
      />
      <div
        className="absolute inset-0"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      >
        <img
          src={before}
          alt="Sorriso prima del trattamento"
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
          data-testid="before-photo"
        />
      </div>

      <span className="absolute top-4 left-4 rounded-full bg-ink/70 text-ivory text-xs font-semibold px-3.5 py-1.5 backdrop-blur">
        {beforeLabel}
      </span>
      <span className="absolute top-4 right-4 rounded-full bg-teal text-white text-xs font-semibold px-3.5 py-1.5">
        {afterLabel}
      </span>

      <div
        className="absolute top-0 bottom-0 w-px bg-white/90 shadow-[0_0_12px_rgba(0,0,0,0.35)]"
        style={{ left: `${pos}%` }}
      />
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-white shadow-lift flex items-center justify-center text-ink"
        style={{ left: `${pos}%` }}
        data-testid="before-after-handle"
      >
        <MoveHorizontal size={18} />
      </div>
    </div>
  );
}